"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M14.828 14.828a4 4 0 1 1-5.656-5.656 4 4 0 0 1 5.656 5.656Zm-1.414-1.414a2 2 0 1 0-2.828-2.828 2 2 0 0 0 2.828 2.828Z",
      clipRule: "evenodd"
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M24 12c0 4.97-5.372 9-12 9-6.627 0-12-4.03-12-9s5.373-9 12-9c6.628 0 12 4.03 12 9Zm-4.715 4.764C21.078 15.42 22 13.715 22 12c0-1.714-.922-3.419-2.715-4.764C17.492 5.891 14.923 5 12 5s-5.492.891-7.285 2.236C2.922 8.58 2 10.285 2 12c0 1.714.922 3.419 2.715 4.764C6.508 18.109 9.077 19 12 19s5.492-.891 7.285-2.236Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};